import { collection, orderBy, where, query, getDocs } from "firebase/firestore";

import { db } from "configs";
import { Utils } from "utils";
import { IMember, Iterable } from "types";
import { createDoc } from "utils/firestore";
import { COLLECTIONS } from "constants/firebase";

export const list = async (email?: string) => {
  const c = collection(db, COLLECTIONS.MEMBERS);

  const constraints: any[] = [orderBy("createdAt", "desc")];

  if (email) {
    constraints.push(where("email", "==", email));
  }

  const documents = await getDocs(query(c, ...constraints));
  const members = Utils.Helpers.castDocs<Iterable<IMember>>(documents);
  return members;
};

export const create = async (data: any) => {
  return createDoc(COLLECTIONS.MEMBERS, data);
};
